import { getEventLastSeen } from '@gonfalon/openapi/operations/getEventLastSeen';
import { getMetricEventByEventKeyAndDataSource } from '@gonfalon/openapi/operations/getMetricEventByEventKeyAndDataSource';
import { getMetricEventDefinitionByDataSource } from '@gonfalon/openapi/operations/getMetricEventDefinitionByDataSource';
import { getMetricEventDefinitionInstancesByDataSource } from '@gonfalon/openapi/operations/getMetricEventDefinitionInstancesByDataSource';
import { getMetricEventInstances } from '@gonfalon/openapi/operations/getMetricEventInstances';
import { getMetricEventsByProject } from '@gonfalon/openapi/operations/getMetricEventsByProject';

import { createQueryOptions } from '../internal/createQueryOptions';

export const getMetricEventDefinitionByDataSourceQuery = createQueryOptions(getMetricEventDefinitionByDataSource);

export const getMetricEventInstancesQuery = createQueryOptions(getMetricEventInstances);

export const getMetricEventsQuery = createQueryOptions(getMetricEventsByProject);

export const getMetricEventDefinitionInstancesByDataSourceQuery = createQueryOptions(
  getMetricEventDefinitionInstancesByDataSource,
);

export const getMetricEventByEventKeyAndDataSourceQuery = createQueryOptions(getMetricEventByEventKeyAndDataSource);

export const getEventLastSeenQuery = createQueryOptions(getEventLastSeen);
